import React, { useEffect, useState } from 'react';
import request from '../../../Helpers/API';
import { useHistory } from "react-router-dom";
import PlantillaScreen from '../../helpers/PlantillaScreen';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoaderScreen } from '../../components/LoaderScreen';
import { Button, Select, MenuItem, InputLabel, FormControl, Stack } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';

export const FiltroScorecard = () => {
    const history = useHistory();
    const [data, setData] = useState([]);
    const [ejercicio, setEjercicio] = useState(new Date().getFullYear());
    const [sucursal, setSucursal] = useState(-998);
    var sucursalselect;
    var ejercicioselect;
    var año = new Date().getFullYear();

    const handleChangeAño = (event) => {
        setEjercicio(event.target.value);
        ejercicioselect = event.target.value;
    };

    const handleChangeSucursal = (event) => {
        setSucursal(event.target.value);
        sucursalselect = event.target.value;
    };

    const onHome = () => {
        history.push("/Ventas/Main")
    };

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoVendedoresFiltro/Obtener_Vendedores_Filtro?idsucursalfiltro=-998`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
            })
    }, []);

    const handleBuscar = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ListadoVendedoresFiltro/Obtener_Vendedores_Filtro?idsucursalfiltro=${sucursal}&ejercicio=${ejercicio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setData(result)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
            })
    };


    return (
        // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <PlantillaScreen
            titulo={"FILTRO DE SCORECARD"}
            className_main={1}
            className={"filtro-scorecard"}
        >
            <LoaderScreen loader={loader} />
            <div className='filtro-scorecard-encabezado-objetivo'>
                <div className="filtro-scorecard-Container">
                    <div className='filtro-scorecard-dropdownlists'>
                        <Stack direction="row" spacing={2}>
                            <FormControl sx={{ height: 40, width: 120 }} size="small">
                                <InputLabel id="demo-simple-select-label">Ejercicio</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    defaultValue={año}
                                    label="Ejercicio"
                                    onChange={handleChangeAño}
                                    size="small"
                                >
                                    <MenuItem value={año - 1}>{año - 1}</MenuItem>
                                    <MenuItem value={año}>{año}</MenuItem>
                                    <MenuItem value={año + 1}>{año + 1}</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl sx={{ height: 40 }} fullWidth size="small">
                                <InputLabel id="demo-simple-select-label-sucursal">Sucursal</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label-sucursal"
                                    id="demo-simple-select-sucursal"
                                    defaultValue={-998}
                                    label="Sucursal"
                                    onChange={handleChangeSucursal}
                                    size="small"
                                >
                                    <MenuItem value={-998}>TODAS LAS SUCURSALES</MenuItem>
                                    <MenuItem value={1}>NAVOLATO</MenuItem>
                                    <MenuItem value={2}>TEPIC</MenuItem>
                                    <MenuItem value={11}>CAIMANERO</MenuItem>
                                    <MenuItem value={12}>SAN JOSE</MenuItem>
                                    <MenuItem value={21}>ELDORADO</MenuItem>
                                    <MenuItem value={22}>SANTIAGO I.</MenuItem>
                                    <MenuItem value={31}>COSTA RICA</MenuItem>
                                    <MenuItem value={32}>TECUALA</MenuItem>
                                    <MenuItem value={41}>LA CRUZ</MenuItem>
                                    <MenuItem value={51}>EL ROSARIO</MenuItem>
                                    <MenuItem value={52}>SAN VICENTE</MenuItem>
                                    <MenuItem value={61}>VILLA UNION</MenuItem>
                                </Select>
                            </FormControl>

                            <Button
                                variant="contained"
                                onClick={handleBuscar}
                                sx={{ height: 40, padding: '0 12px', minWidth: 80 }}
                                size="small"
                            >
                                Buscar
                            </Button>
                        </Stack>
                    </div>
                    <div className='filtro-scorecard-tabla scroll-4'>
                        <table cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr className='filtro-scorecard-tabla-columnas'>
                                    <th className="columna-id">ID</th>
                                    <th>
                                        <div className='columna-nombre'>NOMBRE DE VENDEDOR</div>
                                    </th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {index === 0 || item.sucursal !== data[index - 1].sucursal ? (
                                            <tr className="nombre-sucursal">
                                                <td colSpan="2"><strong>{item.sucursal}</strong></td>
                                                <td className='celda-editar'><div className="cotizaciones-acciones-listado"> <div
                                                    className="boton-editar-cotizaciones"
                                                    onClick={() => history.push("/Ventas/ScorecardSucursal", { ...item, ejercicio: ejercicio })}
                                                >
                                                    <VisibilityIcon /> Revisar
                                                </div></div></td>
                                            </tr>
                                        ) : null}
                                        <tr className='nombre-vendedor'>
                                            <td>{item.idempleado}</td>
                                            <td>{item.vendedor}</td>
                                            <td className='celda-editar'>
                                                <div className="cotizaciones-acciones-listado"><div
                                                    className="boton-editar-cotizaciones"
                                                    onClick={() => history.push("/Ventas/ScorecardObjetivoVendedor", { ...item, ejercicio: ejercicio })}
                                                >
                                                    <VisibilityIcon /> Revisar
                                                </div> </div></td>
                                        </tr>
                                    </React.Fragment>
                                ))}
                                {sucursal === -998 && (
                                    <tr className="nombre-sucursal">
                                        <td colSpan="2"><strong>GRUPO</strong></td>
                                        <td className='celda-editar'>
                                            <div className="cotizaciones-acciones-listado">
                                                <div
                                                    className="boton-editar-cotizaciones"
                                                    onClick={() => history.push("/Ventas/ScorecardGrupo", { ejercicio: ejercicio })}
                                                >
                                                    <VisibilityIcon /> Revisar
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
            <div>
                <div className='home' onClick={() => onHome()}>
                    <ArrowBackIcon /> Regresar
                </div>
            </div>
        </PlantillaScreen>
        // </div>
    )
}
